module.exports = __webpack_public_path__ + "files/1d3fee9996bc91f0f5b157969acd2c6a.png";